import React from 'react'
import "./translation.css"
import TranslationContext from '../../../contexts/TranslationContext'
import StatusContext from '../../../contexts/StatusContext';
import { useLocation } from 'react-router-dom'
import { useState,useEffect } from "react";
import {NavBarTranslation} from '../../main/navbartranslation/NavBarTranslation'
import {ResponseDisplay} from "../responsedisplay/ResponseDisplay"
import {PromptWithIcon} from '../promptwithicon/PromptWithIcon';


import { AlertDialog } from '../alertdialog/AlertDialog'
import Stack from '@mui/material/Stack'
import {PushButton} from '../pushbutton/PushButton'
import { AvailableCredits } from '../availablecredits/AvailableCredits';
import LanguageIcon from '@mui/icons-material/Language';
import { DialogTranslationLanguage } from './DialogTranslationLanguage';
import { WaitonResponse } from '../waitonresponse/WaitonResponse';
import AIButton from '../aibutton/AIButton';
import { DialogSelectModels } from '../aibutton/DialogSelectModels';


export const Translation = () => {
    const alertYes = () => {
        console.log("AlertYes")
        onClearChat()
        closeDialogBox()
    }

    const alertCancel = () => {
        console.log("AlertCancel")
        closeDialogBox()
    }
  
    
    let {
        onClearChat,
        promptsandresponses,
        displaySample,
        confirmDelete, 
        changeConfirmDelete,
        onDeletePrompt,
        prompt,
        setPrompt,
        onTranslate,
        status,
        language,
        setShowTranslationLanguages,

    } = React.useContext(TranslationContext);

    let {
        isMobile,
        scrollRef,
        changeLanguage,

        openDialog,
        openDialogBox,
        closeDialogBox,
        onCopy,
        focusRef,
        handleFocus,

        getAIModel,
        getAIProvider,

        onClickAIButton,
       
    } = React.useContext(StatusContext);

   
    const [showPromptsName, setShowPromptsName] = useState(changeLanguage('translation', 'showprompts'));
    const [showPrompts, setShowPrompts] = useState(false);

 
    var  sample ='';
    const location = useLocation()
    if (location.state !== null)
         sample = location.state.sample

    useEffect(() => {
    const setSample = () => {
        
        if (sample)
        {
            displaySample(sample)
            
            location.state.sample = '';
        }
    }
    setSample();

    }, [sample, displaySample, location.state])   

    const onShowLanguages = () => {
        console.log("onShowLanguages")
        setShowTranslationLanguages(true)
    }
    
   
    const onClickShowPrompts =() => {
        if (showPrompts === true)
        {
         setShowPromptsName(changeLanguage('translation', 'showprompts'))
        }
        else setShowPromptsName(changeLanguage('translation', 'hideprompts'))
        setShowPrompts(!showPrompts)

        handleFocus()

    }

return (
    <div className="homeContainer">

                  
                {
                    isMobile() &&
                        <AIButton pane={0} provider = {getAIProvider()} model = {getAIModel()} onClick = {()=>{onClickAIButton(0)}}/>
                }
                
               
                    <NavBarTranslation title={changeLanguage('translation', 'navbartitle')}/>
                   
                    <div className="response-markdown" ref = {scrollRef}>
                      
                            {
                                Array.isArray(promptsandresponses) &&
                                promptsandresponses.map((item) => (
                                    <ResponseDisplay key= {item.id} displayprompt = {item} displayicons = {confirmDelete[promptsandresponses.indexOf(item)].state}
                                        changeConfirmDelete={changeConfirmDelete}
                                        onDeletePrompt={onDeletePrompt}
                                        onCopy={onCopy}
                                        showprompts = {showPrompts} showRefresh={false}/>
                                    ))
                            } 
                   </div> 
                      {
                        (!status) &&
                            <WaitonResponse />
                      }   
                   
                   <hr className = 'separator'></hr>
                    
                    <div>
                    <PromptWithIcon prompt = {prompt} setPrompt={setPrompt} onSubmit={onTranslate} placeholdertext={changeLanguage('translation', 'promptplaceholder')}/>
                   
                    </div>
                   
                    <div style = {{paddingTop:'10px'}}>
                        <LanguageIcon style={{color: 'maroon'}} onClick={onShowLanguages}/>
                            <label className='navbarFonts'>{changeLanguage('translation','translateto')} {language}</label>
                    </div>
                    {
                        (status) && <label className='statusLabel'>{status}</label>
                    }
               
                    <div ref = {focusRef} className="mainButtons">
                        <Stack direction="row" spacing={2}> 
                             {
                                !isMobile() &&
                                    <AIButton pane={0} provider = {getAIProvider()} model = {getAIModel()} onClick = {()=>{onClickAIButton(0)}}/>
                             } 
                            <PushButton onClick={openDialogBox} label =  {changeLanguage('translation','clearall')}/>
                            <PushButton onClick={onClickShowPrompts} label =  {showPromptsName}/>
                        </Stack>
                      
                     <AvailableCredits />
                    
                    </div>
              
                    <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {openDialog} closeDialog = {closeDialogBox} prompt="Do you want to clear data?"/>
                    <DialogTranslationLanguage />
                     <DialogSelectModels />
        </div>   
    )
}